function stringToColor(value: string): string {
  let hash = 0;

  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) % 16777215;
  }

  const red = hash % 256;
  const green = Math.floor(hash / 256) % 256;
  const blue = Math.floor(hash / 65536) % 256;

  return `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
}

function getInitials(name: string): string {
  const parts = name
    .split(' ')
    .map((part) => part.trim())
    .filter(Boolean);

  const first = parts[0]?.[0] ?? '';
  const second = parts[1]?.[0] ?? '';
  const initials = `${first}${second}`.toUpperCase();

  return initials || '?';
}

export function stringAvatar(name: string): { sx: { bgcolor: string; color: string }; children: string } {
  return {
    sx: {
      bgcolor: stringToColor(name),
      color: '#000 !important',
    },
    children: getInitials(name),
  };
}
